<template>
    <el-dialog title="" :visible="visible" class="small-edit-dialog" append-to-body center :before-close="onBeforeClose" :close-on-click-modal="false" width="350px" @open="onOpen">
        <div class="title">填寫匯費</div>
        <el-form :model="form" :rules="rules" ref="form" label-position="top" v-loading="isLoading" @submit.prevent.native="submitForm">
            <el-form-item prop="amt">
                <template slot="label">匯費金額（{{ cny }}）</template>
                <money-input v-model="form.amt" :precision="cny == '新台幣' ? 0 : 4" />
            </el-form-item>
            <el-form-item v-if="cny !== '新台幣'" prop="rat">
                <template slot="label">匯率</template>
                <money-input v-model="form.rat" :precision="cny == '新台幣' ? 0 : 4" />
            </el-form-item>
            <div class="actions">
                <el-button type="primary" class="primary-action extra" @click="submitForm" icon="el-icon-check">
                    送出
                </el-button>
            </div>
        </el-form>
    </el-dialog>
</template>

<script>
import _ from 'lodash';

export default {
    props: ['visible', 'sno', 'amt', 'cny', 'rat'],
    computed: {
        currencyList() {
            return this.$store.getters['cny/cnyOptions'];
        },
    },
    data() {
        return {
            isLoading: false,
            income: null,
            form: { amt: null, rat: 1 },
            rules: {
                amt: [
                    {
                        required: true,
                        message: '請選擇匯費',
                        trigger: 'blur',
                    },
                ],
            },
            incomeList: [],
            subIncomeList: [],
        };
    },
    methods: {
        onOpen() {
            this.form.amt = this.amt;
            if (this.rat) this.form.rat = this.rat;
            else this.form.rat = _.find(this.currencyList, ['cnynam', this.cny]).rat;
        },
        onBeforeClose() {
            this.$emit('close', false);
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const data = {
                        sno: this.sno,
                        feE_AMT: this.form.amt,
                        rat: this.form.rat,
                    };

                    this.isLoading = true;
                    this.$api({
                        url: '/RemittancesDetailPage/UpdateFee',
                        method: 'POST',
                        data,
                    })
                        .then(() => {
                            this.$emit('close', true);
                        })
                        .finally(() => {
                            this.isLoading = false;
                        });
                }
            });
        },
    },
};
</script>
